// extracted by mini-css-extract-plugin
export default {"cls1":"gTKGlgMPzNkcPzjR_xnA","cls2":"QQsDawMSgkGOyn9Nc_Yz gTKGlgMPzNkcPzjR_xnA"};